export default __webpack_public_path__ + "static/media/no-vouchers-placeholder.58a07f26.svg";